import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { PropsWithChildren } from "react";
import { useEnsureUserTeamMembership } from "./useEnsureUserTeamMembership";

// we want to show loading screen while we are checking if the user is a member of a team,
// it avoids showing the content of the page for a split second before redirecting to the team selection page
// if the user is not a member of a team
export const EnsureUserTeamMembership = ({ children }: PropsWithChildren) => {
  const { isVerified } = useEnsureUserTeamMembership();

  if (!isVerified) {
    return <SimpleDefaultLoadingScreen />;
  }

  return <>{children}</>;
};
